/** The invoice list's send-status keys (InvoiceSendStatusKeys) and «پیش‌فاکتور». */
export type InvoiceUsageStatus =
  | 'notsend'
  | 'errored'
  | 'pending'
  | 'unknown'
  | 'success'
  | 'canceled'
  | 'proforma'

/** One invoice a goods/service or a buyer is used in, as the latest version of its chain. */
export type InvoiceUsageItem = {
  invoiceId: number
  no?: string | null
  /** Jalali, without the time. */
  invoiceDate?: string | null
  subject: number
  subjectTitle?: string
  status?: InvoiceUsageStatus | null
  statusTitle?: string
  /** The invoice is in the invoice archive. */
  archived?: boolean
  /** How many versions of the invoice (original, corrections, archived drafts…) carry the row. */
  versions?: number
  /** Only an earlier version or an archived referral draft carries it, not the latest version. */
  notInLatestVersion?: boolean
}

/**
 * One page of the invoices behind a row's «uc» (backend InvoiceUsage): one invoice however many
 * versions its chain has.
 */
export type InvoiceUsagePage = {
  total: number
  page: number
  itemsPerPage: number
  hasMore: boolean
  items: InvoiceUsageItem[]
}

/** Reads one page as the backend sends it (`{data: InvoiceUsagePage}`), tolerating missing fields. */
export const readInvoiceUsagePage = (
  data: Partial<InvoiceUsagePage> | undefined | null,
  page: number,
  itemsPerPage: number
): InvoiceUsagePage => ({
  total: Number(data?.total || 0),
  page: Number(data?.page || page),
  itemsPerPage: Number(data?.itemsPerPage || itemsPerPage),
  hasMore: Boolean(data?.hasMore),
  items: data && Array.isArray(data.items) ? data.items : [],
})
